// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import FileOutlinedSvg from "@ant-design/icons-svg/lib/asn/FileOutlined";
import AntdIcon from "../components/AntdIcon";
const FileOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: FileOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    FileOutlined.displayName = "FileOutlined";
}
export default /*#__PURE__*/ React.forwardRef(FileOutlined);
